<template>
  <div class="instructions">
    <label class="form-control-label">Instructions</label>
    <draggable 
    v-model="sortedInstructions" 
    class="instructions__container">
      <div
        v-for='(item, index) in sortedInstructions'
        :key='item.id'
        :data-id="index"
        draggable
        @start="startDrag(evt)" 
        @end="onDrop(evt)"
      >
        <div 
          class='drag-el'
        >
          <p class="step list-steps">
            <span class="steps">{{ index + 1 }}</span>
          </p>
          <p class="instruction">
            <i class="fas fa-arrows-alt"></i>
            <span class="instruction__text" v-html="item.instruction"></span>
            <span
              v-on:click="removeInstruction(index)"
              class="shortcut-media avatar rounded-circle bg-gradient-red">
              <i class="fas fa-minus"></i>
            </span>
          </p>
        </div>
      </div>
    </draggable>
    <div class="instructions__add">
      <label class="form-control-label">Add Instruction</label>
      <html-editor
        v-model="instruction">
      </html-editor>
      <button
        class="btn base-button btn-secondary"
        v-on:click.prevent="addInstruction"
      >
        Add Instruction
      </button>
    </div>
  </div>
</template>

<script>
import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
import draggable from 'vuedraggable';

export default {
  name: 'Instructions',
  components: {
    HtmlEditor,
    draggable
  },
  props: {
    instructions: Array
  },
  data () {
    return {
      savedInstructions: this.instructions,
      instruction: ''
    }
  },
  computed: {
    sortedInstructions: {
        get: function() {
          return this.savedInstructions
        },
        set: function(value) {
          for (const property in value) {
            value[property].sortOrder = (parseInt(property) + 1)
          }
          this.savedInstructions = value;
        },
      }
  },
  methods: {
    addInstruction () {
      var sortOrder = this.savedInstructions.length == 0 ? 1 : this.savedInstructions.length + 1
      var instObj = {}
      instObj.instruction = this.instruction
      instObj.sortOrder = sortOrder
      this.savedInstructions.push(instObj)
      this.instruction = ''
    },
    startDrag: (evt) => {
      //evt.dataTransfer.dropEffect = 'move'
      //evt.dataTransfer.effectAllowed = 'move'
      //evt.dataTransfer.setData('itemID', item.id)
      //evt.dataTransfer.setDragImage(img, 10, 10);
    },
    onDrop (evt) {
      //const itemID = evt.dataTransfer.getData('itemID')
      //const item = this.savedInstructions.find(item => item.id == itemID)
      //item.step = list
    },
    removeInstruction(index){
      this.savedInstructions.splice(index, 1);
    }
  }
}
</script>